import React from 'react'
import SpinningIcon from '../Template/SpinningIcon'
import styled from '../../theme'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 50px;
`

function Loader() {
  return (
    <Wrapper>
      <SpinningIcon/>
    </Wrapper>
  )
}

export default Loader
